import Carousel from '../../components/base/Carousel';

/**
 * Блок рекомендаций
 */
export default () => {
    const recommendationsCarousel = new Carousel($('.js-carousel-recommendations'));

    $(document).ready(() => {
        if (recommendationsCarousel) {
            recommendationsCarousel.init(
                {},
                {
                    loop: false,
                    slidesPerView: 3,
                    breakpoints: {
                        767: {
                            slidesPerView: 2,
                        },
                    },
                }
            );
        }
    });
};
